/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { GalleryContext } from "../context/gallery-context";
import SearchFilter from "components/search-filter-list/search-filter-list";
import { ImageListGallery } from "../gallery/image_list_gallery";
import { useMountedState } from "react-use";

const ImageDialogGalleryPanel = () => {

    const {
        images = [],
        setImages,
        searchFunction
    } = useContext(GalleryContext);
    const [needsRefresh, setNeedsRefresh] = React.useState(false);
    const mounted = useMountedState();

    return (
        <Fragment>
            <div className="simplicity-image-selector-window-content-gallery">
                <SearchFilter
                    items={images}
                    setItems={setImages}
                    autoLoad={true}
                    searchFunction={searchFunction}
                    needsRefresh={needsRefresh}
                    setNeedsRefresh={setNeedsRefresh}
                    instruction={"Select from existing images"}
                    mounted={mounted}
                >
                    <ImageListGallery />

                </SearchFilter>
            </div>
        </Fragment>
    );
};

export { ImageDialogGalleryPanel };
